module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/cloud-download-6a262448461da5c6712810564741f216.svg";